import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import styled from 'styled-components';
import es from "date-fns/locale/es";
import Dropdown from './Dropdown';
import { getAllsContactsPagination, updateContactById, getContactByID, createEvent } from "../../endpoints"
import { obtenerFechaYHoraActual } from "../../Utils/index"
import moment from 'moment';
import 'moment/locale/es'
import DateTime from 'react-datetime';
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const modifiedEs = {
  ...es,
  localize: {
    ...es.localize,
    month: (monthIndex, options) => {
      const monthName = es.localize.month(monthIndex, options);
      return monthName.charAt(0).toUpperCase() + monthName.slice(1);
    },
  },
};
moment.locale('es');

export default function ModalCalendario(
  {
    onClose,
    updateContactById,
    contacto,
    stopPropagation,
    setSeActualizoContacto,
    getContactID,
    setContacts,
    scrollContainerRef,
    statusContactFilter,
    user
  }) {

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [statusContact, setStatusContact] = useState(contacto.status || null);
  const [viaDeContacto, setViaDeContacto] = useState(contacto.viaDeContacto || null);
  const [observaciones, setObservaciones] = useState(null)
  const [agendar, setAgendar] = useState(false);
  const navigate = useNavigate();
  const [newEvent, setNewEvent] = useState({ title: '', start: null, end: null });

  useEffect(() => {
    localStorage.setItem("viaDeContacto", JSON.stringify(viaDeContacto));
  }, [viaDeContacto])
  useEffect(() => {
    localStorage.setItem("statusContact", JSON.stringify(statusContact));
  }, [statusContact])
  useEffect(() => {
    localStorage.setItem("selectedDate", JSON.stringify(selectedDate));
  }, [selectedDate])

  useEffect(() => {
    const viaDeContactoLocalStorage = JSON.parse(localStorage.getItem("viaDeContacto"));
    if (viaDeContactoLocalStorage) {
      setViaDeContacto(viaDeContacto)
    }
    const statusContactLocalStorage = JSON.parse(localStorage.getItem("statusContact"));
    if (statusContactLocalStorage) {
      setStatusContact(statusContactLocalStorage)
    }
    const selectedDateLocalStorage = JSON.parse(localStorage.getItem("selectedDate"));
    if (selectedDateLocalStorage) {
      setSelectedDate(selectedDateLocalStorage)
    }
    const observacioneLocalStorage = JSON.parse(localStorage.getItem("observacion"));
    if (observacioneLocalStorage) {
      setObservaciones(observacioneLocalStorage)
    }

  }, [contacto.id]);

  const statusOptions = [
    "No Contactado",
    "Contactado",
    "Sin Respuesta",
  ]

  const viaDeContactoOptions = [
    "Whatsapp",
    "Telefono",
    "Instagram",
    "Otro"
  ]

  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeChange = (event) => {
    setTime(event.target.value);
  };
  const handleGuardar = () => {
    const fechaSeleccionada = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';
    const horaSeleccionada = selectedTime ? selectedTime : '';
    const fechaHora = `${fechaSeleccionada}T${horaSeleccionada}:00.000Z`;
    if (
      !viaDeContacto ||
      !statusContact ||
      !observaciones
    ) {
    } else {
      if (!agendar) {
        updateContactById({
          id: contacto.id,
          fechaDeContacto: obtenerFechaYHoraActual,
          viaDeContacto: viaDeContacto,
          status: statusContact,
          observaciones: observaciones,
          idAsesorAsignado: user.id
        }).then((response) => {
          if (response.status === 200) {
            if (statusContact === "Contactado") {
              navigate('/seguimientos/' + `${contacto.id}`)
            }
            setSeActualizoContacto(true)
            getAllsContactsPagination({
              page: 1,
              perPage: 30,
              userId: user.id,
              status: statusContactFilter,
              userType: user.type
            }).then((res) => {
              if (res.status === 200) {
                setContacts(res.data.contacts)
                if (scrollContainerRef.current) {
                  scrollContainerRef.current.scrollTop = 0;
                }
              } else {
              }
            })
            getContactID(contacto.id)
            onClose();
          } else {
          }
        })
      } else {
        if (date === '' || date === '') {
          Swal.fire({
            icon: "error",
            title: "Es obligatorio seleciona fecha y hora del recordatorio",
            confirmButtonText: "Listo",
            confirmButtonColor: "#6f120f",
          });
        } else {
          createEvent({
            date: date,
            time: time,
            objetoRelacionado: contacto.id,
            detalle: observaciones,
            userId: user.id
          })
          updateContactById({
            id: contacto.id,
            fechaDeContacto: obtenerFechaYHoraActual,
            viaDeContacto: viaDeContacto,
            status: statusContact,
            observaciones: observaciones,
            idAsesorAsignado: user.id
          }).then((response) => {
            if (response.status === 200) {
              if (statusContact === "Contactado") {
                navigate('/seguimientos/' + `${contacto.id}`)
              }
              setSeActualizoContacto(true)
              getAllsContactsPagination({
                page: 1,
                perPage: 30,
                userId: user.id,
                status: statusContactFilter,
                userType: user.type
              }).then((res) => {
                if (res.status === 200) {
                  console.log(res.data, "ASDASD")
                  setContacts(res.data.contacts)
                  if (scrollContainerRef.current) {
                    scrollContainerRef.current.scrollTop = 0;
                  }
                } else {
                }
              })
              getContactID(contacto.id)
              onClose();
            } else {
            }
          })
        }
      }
    }
  };
  const handleCancelar = () => {
    onClose();
  };

  const handleTextAreareaOnChange = (e) => {
    localStorage.setItem("observacion", JSON.stringify(e.target.value));
    setObservaciones(e.target.value);
  }

  return (
    <ModalWrapper onClick={handleCancelar}>
      <ModalContent onClick={stopPropagation}>
        <span>Seleccione fecha y hora del contacto *</span>
        <DayPicker
          mode="single"
          selected={selectedDate}
          onSelect={setSelectedDate}
          locale={modifiedEs}
        />
        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Via de Contacto *</span>
        <Dropdown
          Containerwidth={'100%'}
          options={viaDeContactoOptions}
          selectedOption={viaDeContacto}
          setSelectedOption={setViaDeContacto}
        />
        <span style={{
          fontFamily: "'Montserrat', sans-serif"
        }}>Estado *</span>
        <Dropdown
          Containerwidth={'100%'}
          options={statusOptions}
          selectedOption={statusContact}
          setSelectedOption={setStatusContact}
        />
        <span>Observaciones *</span>
        <TextArea
          placeholder='Si desea puede dejar una observacion acerca de su última comunicación..'
          value={observaciones}
          onChange={(e) => handleTextAreareaOnChange(e)}
        />
        {
          !agendar ?
            <BotonCalendar
              onClick={() => setAgendar(true)}>
              <span>Agregar Recordatorio +</span>
            </BotonCalendar>
            :
            <BotonCalendar
              onClick={() => setAgendar(false)}>
              <span>Remover Recordatorio</span>
            </BotonCalendar>
        }

        {
          agendar ?
            <>
              <span>Seleccione la fecha en la que quiere ser notificado * </span>
              <Input
                type="date"
                value={date}
                onChange={handleDateChange}
              />
              <Input
                type="time"
                value={time}
                onChange={handleTimeChange}
              />
            </> : null
        }

        <ButtonGroup>
          <Button style={{
            backgroundColor: '#780000',
          }} onClick={handleCancelar}>CANCELAR</Button>
          <Button style={{
            backgroundColor: '#003049',
          }} onClick={handleGuardar}>GUARDAR</Button>
        </ButtonGroup>
      </ModalContent>
    </ModalWrapper>
  );
}

const Input = styled.input`
  width: -webkit-fill-available;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 10px;
  user-select: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
`;

const BotonCalendar = styled.div`
border-radius: 8px;
    border: solid 2px #cccccc;
    box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
    cursor: pointer;
    height: auto;
    margin: 0px 0px 0px 0px;
    align-content: center;
    width: auto;
    gap: 8px;
    font-family: 'Montserrat',sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #07082c;
    padding: 4px 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  
  &:focus {
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }
  &:active {
    transform:scale(0.90)
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: -webkit-fill-available;
  max-width:400px;
  padding: 20px auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  max-height:80vh;
  overflow-y: auto;
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  gap:16px;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  margin-top: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight:500;
  font-family: 'Montserrat', sans-serif;
  &:hover {
    background-color: #0056b3;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  width:-webkit-fill-available;
  justify-content: space-between;
  align-items: center;
`;

const TextArea = styled.textarea`
  margin-top: 10px;
  padding: 10px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  min-height:80px;
  resize: none;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
  }
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;